import type { FC } from "react";

import { useTranslate } from "@refinedev/core";

import { Badge, Typography, theme } from "antd";

type PaginationTotalProps = {
  total: number;
  entityName?: string;
  lastUpdate?: React.ReactNode;
  textAlign?: "left" | "center" | "right";
};

export const PaginationTotal: FC<PaginationTotalProps> = ({
  total,
  entityName,
  lastUpdate,
  textAlign = "left",
}) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  return (
    <div
      style={{
        marginLeft: "16px",
        marginRight: "30px",
        display: lastUpdate ? "flex" : "block",
        alignItems: "center",
        height: "100%",
        justifyContent: "space-between",
        textAlign,
      }}
    >
      {lastUpdate && (
        <Typography.Text
          style={{
            color: token.colorTextTertiary,
          }}
        >
          <Badge
            status="success"
            style={{ marginRight: "6px" }}
            classNames={{ indicator: "pulse" }}
          />{" "}
          {lastUpdate}
        </Typography.Text>
      )}
      <Typography.Text
        style={{
          color: token.colorTextTertiary,
        }}
      >
        {entityName
          ? total + " " + t(`${entityName}`)
          : `${t("results")}: ` + total}
      </Typography.Text>
    </div>
  );
};
